import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener("focus", this.onFocus)
    this.element.addEventListener("blur", this.onBlur)
  }

  disconnect() {
    this.element.removeEventListener("focus", this.onFocus)
    this.element.removeEventListener("blur", this.onBlur)
  }

  onFocus = () => {
    if (this.element.value.trim() === "") {
      this.element.value = "https://"
    }
  }

  onBlur = () => {
    if (this.element.value.trim() === "https://") {
      this.element.value = ""
    }
  }
}